import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";
import { WardConfigurationImpl } from "../data/WardConfigurationImpl";
import { IWardConfigurationRepository } from "../domain/repositories/IWardConfigurationRepository";
import { WardConfigurationUseCase } from "../domain/useCases/WardConfigurationUseCase";
import { WardConfigurationViewModel } from "../presentation/viewModel/WardConfigurationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";
import { DistrictConfigurationInjection } from "features/districtConfiguration/di/DistrictConfigurationInjection";

export class WardConfigurationInjection extends InjectionModule {
  private static readonly wardConfigurationRepositoryToken = Symbol(
    "IWardConfigurationRepository",
  );
  private static readonly wardConfigurationUseCaseToken = Symbol(
    "WardConfigurationUseCase",
  );
  private static readonly wardConfigurationViewModelToken = Symbol(
    "WardConfigurationViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.wardConfigurationRepositoryToken,
      useClass: WardConfigurationImpl,
    },
    {
      scope: "otherRepo",
      token: this.wardConfigurationUseCaseToken,
      useClass: WardConfigurationUseCase,
    },
    {
      scope: "viewModel",
      token: this.wardConfigurationViewModelToken,
      useClass: WardConfigurationViewModel,
    },
  ];

  static getRepo(): IWardConfigurationRepository {
    return this.resolve(this.wardConfigurationRepositoryToken);
  }

  static getUseCase(): WardConfigurationUseCase {
    return this.resolve(this.wardConfigurationUseCaseToken);
  }

  static override initialize(): void {
    ProvinceConfigurationInjection.initialize();
    DistrictConfigurationInjection.initialize();
    super.initialize();
  }
}
